module.exports = __webpack_public_path__ + "static/media/stop-7.e2ca9c97.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/alt-color/stop-7.svg
// module id = 1374
// module chunks = 0